import { render } from "./management.cattle.io.fleetworkspace.vue?vue&type=template&id=456a6c2d&scoped=true"
import script from "./management.cattle.io.fleetworkspace.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.fleetworkspace.vue?vue&type=script&lang=js"

import "./management.cattle.io.fleetworkspace.vue?vue&type=style&index=0&id=456a6c2d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456a6c2d"]])

export default __exports__